// extracted by mini-css-extract-plugin
module.exports = {"banmianTitle":"Zoumadeng_banmianTitle__1AsYn","banmian":"Zoumadeng_banmian__1onHa","content":"Zoumadeng_content__2Gvk_"};